module.exports = __webpack_public_path__ + "static/media/Nene-Henshaw.d7e5721b.png";